import { useRecentImages } from "../../SPA/hooks/recentimages";
import { usePriceList } from "../../Providers/PriceListProvider";
import React, { useMemo, useState } from "react";
import Container from "@material-ui/core/Container";
import { Trans } from "react-i18next";
import ProductPriceInfoPopup from "./ProductPriceInfoPopup";
import { Skeleton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import TemplatesByProductList, { TemplateListItemsSkeleton, } from "./TemplatesByProductList";
import { clientIsDesktop } from "../../../lib/common";
const useStyles = makeStyles((theme) => {
    return {
        typeOptions: {
            backgroundColor: "white",
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            boxShadow: "0px 2px 4px #00000029",
        },
        priceContainer: {
            textAlign: "right",
        },
        productContainer: {
            position: "relative",
        },
        stickyHeader: {
            position: "sticky",
            top: clientIsDesktop() ? 0 : "70px",
            zIndex: 1,
            backgroundColor: "rgba(255, 255, 255, 1)",
            boxShadow: "0px 3px 6px #00000029",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            "& .MuiContainer-root": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            },
            "& h3": {
                fontSize: "15px",
                marginTop: "1em",
                marginBottom: "1em",
                [theme.breakpoints.down("lg")]: {
                    minWidth: "40vw",
                },
            },
            "& div": {
                [theme.breakpoints.down("md")]: {
                    minWidth: "20vw",
                }
            },
        },
        prices: {
            textDecoration: "underline",
            cursor: 'pointer'
        },
    };
});
const ProductsWithTemplates = ({ loading, type, category, canViewWithOwnPictures, templates, separateFromBackground, }) => {
    const { recentImages, loadingImages } = useRecentImages();
    const { getProductByUuid, getPriceAsString } = usePriceList();
    const classes = useStyles();
    console.log("Loading templates of type", type);
    const [showPriceInfo, setShowPriceInfo] = useState(null);
    const products = useMemo(() => {
        if (!templates) {
            return [];
        }
        const obj = templates.reduce((products, template) => {
            const product = products[template.product.uuid] || {
                name: template.product.name,
                uuid: template.product.uuid,
                templates: [],
            };
            product.templates.push(template);
            products[product.uuid] = product;
            return products;
        }, {});
        return Object.keys(obj)
            .map((k) => obj[k])
            .sort((a, b) => {
            console.log('Sorting products', type);
            if (type == "card") {
                for (const format of ["15x15"]) {
                    if (a.name.includes(format) && !b.name.includes(format)) {
                        return -1;
                    }
                    else if (!a.name.includes(format) && b.name.includes(format)) {
                        return 1;
                    }
                }
            }
            else if (type == "calendars") {
                console.log("Compare function", a, b);
                if (a.name.includes("20x30") && !b.name.includes("20x30")) {
                    return -1;
                }
                else if (!a.name.includes("20x30") && b.name.includes("20x30")) {
                    return 1;
                }
                // Pri on 12 pages?
                if (a.name.includes("(12") && !b.name.includes("(12)")) {
                    return -1;
                }
                else if (!a.name.includes("(12") && b.name.includes("(12")) {
                    return 1;
                }
            }
            else if (type == "cards") {
                if (a.name.includes("15x15") && !b.name.includes("15x15")) {
                    return -1;
                }
                else if (!a.name.includes("15x15") && b.name.includes("15x15")) {
                    return 1;
                }
                // Sort by size desc:
                let are, bre;
                if ((are = a.name.match(/(\d+)x(\d+)/)) &&
                    (bre = b.name.match(/(\d)+x(\d+)/))) {
                    const aSize = parseInt(are[1]) * parseInt(are[2]);
                    const bSize = parseInt(bre[1]) * parseInt(bre[2]);
                    if (aSize != bSize) {
                        return bSize - aSize;
                    }
                }
            }
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: "base",
            });
        });
    }, [templates]);
    console.log("Products", products);
    if (loading || loadingImages) {
        return React.createElement(TemplateListSkeleton, null);
    }
    return (React.createElement(React.Fragment, null,
        products.map((product) => {
            const p = getProductByUuid(product.uuid);
            const priceString = getPriceAsString(p, [category]);
            return (React.createElement("div", { key: product.uuid, className: classes.productContainer },
                React.createElement("div", { className: classes.stickyHeader },
                    React.createElement(Container, { onClick: () => setShowPriceInfo(p) },
                        React.createElement("h3", null, product.name),
                        React.createElement("div", { className: classes.priceContainer },
                            priceString,
                            " ",
                            p.productprices.length > 1 && (React.createElement("span", null,
                                " ",
                                "(",
                                React.createElement("span", { className: classes.prices },
                                    React.createElement(Trans, null, "Prices"),
                                    ")")))))),
                React.createElement(Container, { disableGutters: true },
                    React.createElement(TemplatesByProductList, { category: category || "", templates: product.templates, displayTemplateName: type == "photogift", canViewWithOwnPictures: canViewWithOwnPictures, imageList: recentImages, type: type, separateFromBackground: separateFromBackground }))));
        }),
        React.createElement(ProductPriceInfoPopup, { product: showPriceInfo, category: category, open: showPriceInfo, handleClose: () => setShowPriceInfo(null) })));
};
const TemplateListSkeleton = () => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.productContainer },
        React.createElement("div", { className: classes.stickyHeader },
            React.createElement(Container, { disableGutters: true },
                React.createElement("h3", null,
                    React.createElement(Skeleton, { variant: "text" })),
                React.createElement("div", { className: classes.priceContainer },
                    React.createElement(Skeleton, { variant: "text" })))),
        React.createElement(Container, null,
            React.createElement(TemplateListItemsSkeleton, null))));
};
export default ProductsWithTemplates;
